import { useMutation } from '@tanstack/react-query';
import { PermissionsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function usePermissionsControllerDeletePermissionMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['permissionsControllerDeletePermission', accessControlScope],
        mutationFn: async (args) => {
            const api = new PermissionsApi(accessControlConfig);
            return api.permissionsControllerDeletePermission(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=usePermissionsControllerDeletePermissionMutation.js.map